export const PresentationMessageTypes = {
    PresenterConfig: 'presenterConfig',
    Speech: 'speech',
    AudioChunk: 'audioChunk',
    LiveInputAudio: 'liveInputAudio',
};
const textDecoder = new TextDecoder();
const textEncoder = new TextEncoder();
export const encodePresentationFrame = (metadataJson, binary = new Uint8Array()) => {
    const metaBytes = textEncoder.encode(metadataJson);
    const frame = new ArrayBuffer(4 + metaBytes.length + binary.length);
    const view = new DataView(frame);
    view.setUint32(0, metaBytes.length, true);
    new Uint8Array(frame, 4, metaBytes.length).set(metaBytes);
    if (binary.length > 0) {
        new Uint8Array(frame, 4 + metaBytes.length, binary.length).set(binary);
    }
    return frame;
};
export const decodePresentationFrame = (buffer) => {
    const view = new DataView(buffer);
    if (buffer.byteLength < 4) {
        throw new Error('Frame is too short.');
    }
    const metaLength = view.getUint32(0, true);
    if (metaLength > buffer.byteLength - 4) {
        throw new Error('Invalid metadata length.');
    }
    const metadataJson = textDecoder.decode(new Uint8Array(buffer, 4, metaLength));
    const binaryStart = 4 + metaLength;
    const binaryLength = buffer.byteLength - binaryStart;
    const binary = binaryLength === 0
        ? new Uint8Array()
        : new Uint8Array(buffer, binaryStart, binaryLength);
    return { metadataJson, binary };
};
export const getMessageType = (metadataJson) => {
    const metadata = JSON.parse(metadataJson);
    if (!metadata.type) {
        throw new Error('Metadata missing type.');
    }
    return metadata.type;
};
export const createPresenterConfigMessage = (language, textToSpeech) => {
    return JSON.stringify({
        type: PresentationMessageTypes.PresenterConfig,
        language,
        textToSpeech,
    });
};
export const createPresenterConfigFrame = (language, textToSpeech) => {
    return encodePresentationFrame(createPresenterConfigMessage(language, textToSpeech));
};
export const parsePresenterConfig = (metadataJson) => {
    const parsed = JSON.parse(metadataJson);
    if (parsed.type !== PresentationMessageTypes.PresenterConfig) {
        throw new Error('Expected presenterConfig message.');
    }
    return parsed;
};
export const parseSpeech = (metadataJson, binary) => {
    const meta = JSON.parse(metadataJson);
    if (meta.type !== PresentationMessageTypes.Speech) {
        throw new Error('Expected speech message.');
    }
    // Prefer payload embedded in metadata (text frame); keep binary fallback for compatibility.
    const payload = meta.payload ?? JSON.parse(textDecoder.decode(binary));
    return { language: meta.language, payload };
};
export const parseAudioChunk = (metadataJson, binary) => {
    const meta = JSON.parse(metadataJson);
    if (meta.type !== PresentationMessageTypes.AudioChunk) {
        throw new Error('Expected audioChunk message.');
    }
    return { language: meta.language, bytes: binary };
};
export const parseLiveInputAudio = (metadataJson, binary) => {
    const meta = JSON.parse(metadataJson);
    if (meta.type !== PresentationMessageTypes.LiveInputAudio) {
        throw new Error('Expected liveInputAudio message.');
    }
    return binary;
};
